import React from 'react';
import './Banner.css';

function Banner(){
    return(
    <header className='banner'>
        <img src="/imagens/banner.png" alt="bane de cabeçario" />
    </header>
    )
}

export default Banner